// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/smartphone.js';

import { paths } from '../generated/smartphone';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('smartphone', Original, paths);
